<template>
  <div class="serial">
    <!-- ヘッダー -->
    <SimpleHeader :contentName="contentName" />

    <div class="inner flexcenter">
      <div class="serial-controls flexcenter">
        <h3>シリアル番号を入力して利用開始</h3>
        <div class="serial-input flexcenter">
          <input class="serial-text" type="text" v-model.lazy="serial" placeholder="シリアル番号" maxlength="25"
            @input="validate($event)"
            @compositionstart="ignore = true"
            @compositionend="composition($event)"
            @keypress.enter="doActivate">
          <button class="enter" @click="doActivate"><img src="static/images/icon/svg/ar_r_login.svg" alt="enter"></button>
        </div><!-- serial-input flexcenter -->
        <p class="serial-error" v-if="message">{{ message }}</p>
        <p>
          <a class="serial-anchor" href="https://www.sourcenext.com/r/p/rosettastone/eula/" target="_blank">
            Rosetta Stone について
          </a>
        </p>
      </div><!-- serial-controls flexcenter -->
    </div><!-- inner flexcenter -->

    <!-- エラーダイアログ -->
    <ErrorDialog v-if="showErrorDialog" @close="showErrorDialog = false" :message="errorMessage" :buttonKind="errorButtonKind" :routeQuery="{ id: contentId }" />
  </div><!-- serial -->
</template>

<script>
import SimpleHeader from "@/components/Header";
import ErrorDialog from "@/components/Error";
import common from "@/mixin/common";
import http from "@/mixin/http";
import * as constants from "@/mixin/constants";

export default {
  name: "serial",
  data: function() {
    return {
      serial: "",
      message: "",
      ignore: false,
      contentId: this.$route.query.id ? this.$route.query.id : "",
      contentName: "",
      // エラー表示用
      showErrorDialog: false,
      errorMessage: "",
      errorButtonKind: ""
    };
  },
  components: {
    SimpleHeader,
    ErrorDialog
  },
  mixins: [
    common,
    http
  ],
  created: function() {
    this.log("Serial start created");
    this.log("contentId: " + this.contentId);

    this.setContentName();
  },
  mounted: function() {
    this.log("Serial start mounted");

    // GoogleAnalyticsページビューヒット送信
    rosettaGA.sendPageView(constants.GA_PAGEVIEW.TITLE.ACTIVATE, constants.GA_PAGEVIEW.PAGE.ACTIVATE);

    // ローカルストレージ操作初期化処理
    storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN);

    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1) {
      this.fixtHeightForSafariFullWindow();
    }
  },
  methods: {
    /**
     * コンテンツ名称取得
     */
    setContentName: function() {
      var self = this;

      self.log("Serial start setContentName");

      // コンテンツ名取得APIを実行
      self.getContentName(self.contentId).then(function(response) {
        self.log("Serial getContentName result_code: " + response.result_code);
        switch (response.result_code) {
          case "OK":
            self.log("Serial getContentName content_name: " + response.content_name);
            self.contentName = response.content_name;
            break;
          default:
            self.contentName = "";
            break;
        }
      }).catch(function(err) {
        self.log("Serial getContentName error");
        self.contentName = "";
      });
    },
    /**
     * シリアル入力処理実行
     */
    doActivate: function() {
      var self = this;
      self.log("Serial start doActivate");

      // シリアル番号の先頭末尾の空白を除去
      self.serial = self.serial.trim();

      // 空文字の場合は、API実行しない
      if (self.serial.length == 0) {
        self.log("Serial end doActivate: input value empty");

        // GoogleAnalyticsイベントヒット送信
        self.sendGaEventActivate(constants.GA_EVENT.ACTION.FAILURE, "ERR_UNKNOWN");

        self.message = constants.ERR_INVALID_SERIAL;
        return;
      }

      // シリアル入力APIを実行
      self.activate(self.contentId, self.getFormattedSerial()).then(function(response) {
        self.log("Serial activate result_code: " + response.result_code);
        switch (response.result_code) {
          case "OK":
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventActivate(constants.GA_EVENT.ACTION.SUCCESS);

            window.location.replace(response.url);
            break;
          case "WARN_INPUT_PARAM":
          case "INFO_INVALID_SERIAL":
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventActivate(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.message = constants.ERR_INVALID_SERIAL;
            break;
          case "INFO_INVALID_ACCESSKEY":
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventActivate(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.showErrorInvalidAccessKey();
            break;
          default:
            // GoogleAnalyticsイベントヒット送信
            self.sendGaEventActivate(constants.GA_EVENT.ACTION.FAILURE, response.result_code);

            self.message = constants.ERR_UNKNOWN;
            break;
        }
      }).catch(function(err) {
        // GoogleAnalyticsイベントヒット送信
        self.sendGaEventActivate(constants.GA_EVENT.ACTION.FAILURE, "ERR_UNKNOWN");

        self.message = constants.ERR_UNKNOWN;
      });
    },
    /**
     * 入力値検証
     *
     * @param {Object} event イベントオブジェクト
     */
    validate: function(event) {
      // IMEコンポジション中
      if (this.ignore) {
        return;
      }
      // カーソル位置を保持
      var selection = event.target.selectionStart;
      // アルファベット小文字を含むか
      var isIncludeLowerCase = /[a-z]/.test(event.target.value);
      // アルファベット大文字変換
      event.target.value = event.target.value.toUpperCase();
      // アルファベット小文字を含む場合
      if (isIncludeLowerCase) {
        // カーソル位置調整
        event.target.selectionStart = selection;
        event.target.selectionEnd = selection;
      }

      // changeイベントがこない場合があるので、ここで設定する
      this.serial = event.target.value;
    },
    /**
     * IMEコンポジション完了処理
     *
     * @param {Object} event イベントオブジェクト
     */
    composition: function(event) {
      this.ignore = false;
      event.target.value = event.target.value.toUpperCase();

      // changeイベントがこない場合があるので、ここで設定する
      this.serial = event.target.value;
    },
    /**
     * フォーマットされたシリアル番号を取得する
     *
     * @return {String} シリアル番号
     */
    getFormattedSerial: function() {
      this.log("Serial getFormattedSerial input: " + this.serial);
      var firstHyphenIndex = this.serial.indexOf("-");
      if (firstHyphenIndex < 0) {
        this.log("Serial getFormattedSerial result: " + this.serial);
        return this.serial;
      }
      var head = this.serial.substring(0, firstHyphenIndex);
      var tail = this.serial.substring(firstHyphenIndex).replace(/-/g, "");

      var result = head + "-" + tail;
      this.log("Serial getFormattedSerial result: " + result);
      return result;
    },
    /**
     * アクセスキー無効エラーダイアログ表示
     */
    showErrorInvalidAccessKey: function() {
      this.errorMessage = "INFO_INVALID_ACCESSKEY";
      this.errorButtonKind = constants.ERROR_BUTTON_KIND_LOGIN;
      this.showErrorDialog = true;
    },
    /**
     * GoogleAnalyticsイベントヒット送信
     *
     * @param {String} eventAction イベントアクション
     * @param {String} resultCode WebAPI処理結果コード(未指定可)
     */
    sendGaEventActivate: function (eventAction, resultCode) {
      rosettaGA.sendEvent(
        constants.GA_EVENT.GATEGORY.ACTIVATE,
        eventAction,
        constants.GA_EVENT.LABEL.ACTIVATE,
        [null, resultCode]
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/login";
</style>



// WEBPACK FOOTER //
// Serial.vue?5c5ed611